import { render, staticRenderFns } from "./search-specialty.vue?vue&type=template&id=637bfbfc&scoped=true&"
import script from "./search-specialty.vue?vue&type=script&lang=js&"
export * from "./search-specialty.vue?vue&type=script&lang=js&"
import style0 from "./search-specialty.vue?vue&type=style&index=0&id=637bfbfc&scoped=true&lang=less&"
import style1 from "./search-specialty.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637bfbfc",
  null
  
)

export default component.exports